import * as React from 'react'
import { Button, Form } from 'react-bootstrap'


import { copyObject } from '../../../../../utils'

import { VariableDocumentT, getVariableValue, setValueVariables } from '../DocumentVariables'

import { VariablesObj, DefaulVariablesByJobType } from '../../../../../types/Company'
import * as _ from 'lodash'
import InvoiceLineItem from './InvoiceLineItem'
import { InvoiceLineItemT, JobT } from '../../../../../types/Job'
import { InvoiceLineItemObj, InvoiceObj } from '../../InitObjectJob'
import { parseFloatTotal } from '../../../../../utils/utilsT'


interface InvoiceProps {
    company: any
    job: JobT
    jobOrigin: JobT
    updateJob(key: string, value: any): void
    updateDocument(key: string, value: any): void
    isActive?: boolean
    isReceipt?: boolean
}

// invoiceIsDirty
export const invoiceIsDirty = (newJob: JobT): boolean => {
    return getVariableValue('dirty', newJob.documents.invoice.variables)
}

// lineItemsInvoice
export const lineItemsInvoice = (newJob: JobT, document: 'estimate' | 'invoice'): Array<any> => {
    let lineItems = []
    if (document == 'estimate') {
        lineItems = getVariableValue('lineItems', newJob.documents.estimate.variables)
    } else {
        lineItems = getVariableValue('lineItems', getVariablesInvoice(newJob))
    }
    return lineItems ? lineItems : []
}



export const getVariablesInvoice = (newJob: JobT, useDefault: boolean = true): Array<VariableDocumentT> => {
    return newJob.documents.invoice && newJob.documents.invoice.variables ? newJob.documents.invoice.variables : useDefault ? InvoiceObj.variables : []
}

const Invoice: React.FunctionComponent<InvoiceProps> = (props): JSX.Element => {
    const [companyVariables, setComopanyVariables] = React.useState(VariablesObj)
    const [estimateTemp, setEstimateTemp] = React.useState(null)
    // const [isUpdate, setIsUpdate] = React.useState(false)
    const [isReady, setIsReady] = React.useState(false)
    const [jobTypeTemp, setJobTypeTemp] = React.useState('');

    // register function filter when parse job
    React.useEffect(() => {

        setIsReady(true)
    }, [])



    // effect when change estimate
    React.useEffect((): void => {
        //console.log("invoiceIsDirty->invoice")



    }, [props.job.documents.estimate])
    // effect when update company
    React.useEffect((): void => {
        if (props.company && props.company.variables) {
            setComopanyVariables({ ...VariablesObj, ...props.company.variables })
        }
    }, [props.company])







    const addLineItem = (jobType: string = null): void => {
        let documentsClone = copyObject(props.job.documents)
        if (documentsClone.invoice == null) documentsClone.invoice = copyObject(InvoiceObj)
        //
        let lineItemClone = generateLineItem(jobType)

        let lineItems = lineItemsInvoice(props.job, 'invoice');

        lineItems.push(lineItemClone)

        let variables = setValueVariables('lineItems', lineItems, getVariablesInvoice(props.job))

        if (!invoiceIsDirty(props.job)) {
            variables = setValueVariables('dirty', true, variables)
        }

        documentsClone.invoice.variables = variables;
        props.updateDocument('invoice', documentsClone.invoice)
        // updateJob('documents', documentsClone)
    }

    const invoiceLineItems = (): Array<JSX.Element> => {
        // console.log("lineItemsInvoice->invoice", lineItemsInvoice(job, 'invoice'))
        if (props.job.documents.invoice != null) {
            return lineItemsInvoice(props.job, 'invoice').map((lineItem, i) => {
                return (
                    <div key={i}>
                        <InvoiceLineItem
                            lineItem={lineItem}
                            updateLineItem={updateLineItem}
                            removeLineItem={removeLineItem}
                            companyVariables={companyVariables}
                            index={i}
                        />
                    </div>
                )
            })
        }

    }

    const generateLineItem = (jobType: string = null): InvoiceLineItemT => {
        let lineItemClone: InvoiceLineItemT = copyObject(InvoiceLineItemObj)
        if (jobType != null) {
            let item = getDefaultItem(jobType)
            lineItemClone.item = item
            if (companyVariables[item]) {
                lineItemClone.rate = companyVariables[item].value
                lineItemClone.total = lineItemClone.rate * lineItemClone.units
            }
        }

        return lineItemClone;
    }



    //
    const getDefaultItem = (jobType: string = null) => {
        if (jobType && DefaulVariablesByJobType[jobType]) {
            return DefaulVariablesByJobType[jobType]
        }
        return DefaulVariablesByJobType['all']
    }





    const removeLineItem = (index: number): void => {
        let documentsClone = copyObject(props.job.documents)
        let lineItems = lineItemsInvoice(props.job, 'invoice')

        const filteredItems = lineItems.slice(0, index).concat(lineItems.slice(index + 1, lineItems.length))

        // When the first item is removed, it should immediately place an empty card there
        if (filteredItems.length <= 0) {
            let item = generateLineItem(props.job.jobType)
            filteredItems.push(item)
        }

        documentsClone.invoice.variables = setValueVariables('lineItems', filteredItems, props.job.documents.invoice.variables)
        props.updateDocument('invoice', documentsClone.invoice)
        // updateJob('documents', documentsClone)
    }


    const sumLineItems = (lis: Array<InvoiceLineItemT>): number => {
        if (lis.length == 0) return 0
        let lineItem = lis.shift()
        let total = 0
        if (lineItem.item == 'discount') total = sumLineItems(lis) - Number(parseFloat(`${lineItem.total}`).toFixed(2))
        else total = Number(parseFloat(`${lineItem.total}`).toFixed(2)) + sumLineItems(lis)
        return parseFloat(`${parseFloatTotal(total)}`)
    }

    // updateLineItem
    const updateLineItem = (key: string, value: any, index: number): void => {
        let documentsClone = copyObject(props.job.documents)
        let lineItems = lineItemsInvoice(props.job, 'invoice')
        let lineItem = lineItems[index]
        let dirty = invoiceIsDirty(props.job);
        let variables = props.job.documents.invoice.variables;
        // when update line item update estimate dirty
        if (!invoiceIsDirty(props.job) && lineItem[key] != value) {
            variables = setValueVariables('dirty', true, variables);
        }

        lineItem[key] = value
        // update rate and units  pull in  settings  company if item exists
        if (key == 'item' && companyVariables[value]) {
            lineItem['rate'] = companyVariables[value].value
            // lineItem['units'] = reflectorLabel(companyVariables[value],false)
            lineItem.total = lineItem.rate * lineItem.units
        }

        if (key == 'rate' || key == 'units') lineItem.total = lineItem.rate * lineItem.units

        lineItems[index] = copyObject(lineItem)
        variables = setValueVariables('lineItems', lineItems, variables)

        documentsClone.invoice.variables = copyObject(variables)
        props.updateDocument('invoice', documentsClone.invoice)
        // updateJob('documents', documentsClone)
    }
    if (!props.isActive) {
        return null
    }
    return (
        <div className='w-100'>
            <strong>{props.job.client.firstName} {props.job.client.lastName}</strong>
            {invoiceLineItems()}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 30px' }}>
                <span>
                    <Button
                        onClick={(): void => { addLineItem(props.job.jobType) }}
                        variant='info'>
                        Add Line Item
                    </Button>
                </span>
                <span></span>
                <span></span>
                <span></span>
                <span>
                    <Form.Label><strong>Total, $</strong></Form.Label>
                    <Form.Control
                        className='input-material'
                        disabled
                        value={`${parseFloat(`${sumLineItems(copyObject(lineItemsInvoice(props.job, 'invoice')))}`).toFixed(2)}`} />
                </span>
                <span></span>
            </div>
        </div>
    )
}

export default Invoice
